import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      d="M7.526 5.65A1 1 0 0 1 8 6.5v7a1 1 0 1 1-2 0V8.118l-.553.276a1 1 0 1 1-.894-1.788l2-1a1 1 0 0 1 .973.043M12 8a1 1 0 0 1 1-1h14a1 1 0 1 1 0 2H13a1 1 0 0 1-1-1M12 16a1 1 0 0 1 1-1h14a1 1 0 1 1 0 2H13a1 1 0 0 1-1-1M13 23a1 1 0 1 0 0 2h14a1 1 0 1 0 0-2zM6.506 19.025a.75.75 0 0 1 .88 1.12L4.199 24.4A1 1 0 0 0 5 26h3.5a1 1 0 1 0 0-2H6.998L9 21.324l.022-.03A2.75 2.75 0 1 0 4.21 18.7a1 1 0 0 0 1.855.749.75.75 0 0 1 .44-.425"
    />
  </svg>
);
const SvgIconListNumbers = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconListNumbers);
export default Memo;
